import * as React from 'react'
import { type ReactNode, useReducer } from 'react'

import { reducer } from '../state'
import { cwqDialogContext } from './cwqDialogContext'

type Props = {
  children: ReactNode
}

export function CWQDialogContextProvider(props: Props) {
  const { children } = props

  const value = useReducer(reducer, {})

  return (
    <cwqDialogContext.Provider value={value}>
      {children}
    </cwqDialogContext.Provider>
  )
}
